import { render, staticRenderFns } from "./punch.vue?vue&type=template&id=08e74436"
import script from "./punch.vue?vue&type=script&lang=js"
export * from "./punch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports